(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PeopleFranchiserAssociateController', PeopleFranchiserAssociateController)

    /** @ngInject */
    function PeopleFranchiserAssociateController($state, $timeout, $stateParams, LoadingHelper, PersonService, AuthenticationService,
        CompanyService, UtilHelper, PreRegistraterService, sweetAlert, DEFAULT_IDENTIFIERS, SYSTEM_MODULES) {
        const vm = this;
        const companyId = $stateParams.companyId;
        let loggedPersonAvailableCompanies;

        // First step
        vm.searchPerson = () => {
            LoadingHelper.startLoading('.loading-holder');

            PersonService
                .getByDocument(vm.searchPersonData.Document)
                .then(success => {
                    if (success)
                        initStepTwo(success);
                    else
                        initStepThree();
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        // Second step
        vm.getFoundPersonImagePath = () => {
            if (vm.foundPerson.Image)
                return ImagePathHelper.imageResizePath('person', vm.foundPerson.Id, vm.foundPerson.Image, 150, 150);

            return 'api/images/res/100/100/placeholder.jpg';
        }

        vm.associatePerson = isPreRegister => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa ação irá associar a pessoa com as permissões selecionadas!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.loading-holder');

                    handlePersonAssociation(isPreRegister);
                }
            })
        }

        // Shared
        vm.resetPersonSearch = () => {
            vm.personCompanyAssociationData = [];
            vm.errorCantEditSelf = false;
            vm.noCompanyWithPermissions = false;
            vm.showStepOneData = true;
            vm.searchPersonData = {};
            vm.preRegisterPerson = null;
            vm.newUserData = {};
            vm.step = 1;
        }

        init();

        function initStepTwo(foundPerson) {
            const loggedUserId = AuthenticationService.getUser().Id;

            // Logged person can't edit his own relationships
            if (loggedUserId == foundPerson.Id) {
                vm.errorCantEditSelf = true;
                vm.showStepOneData = false;

                LoadingHelper.stopLoading('.loading-holder');
            } else {
                if (vm.urlCompany && vm.urlCompany.Id) {
                    vm.hasCompaniesToAssociate = handleAssociationToUrlCompany(foundPerson);
                } else {
                    vm.hasCompaniesToAssociate = handleAssociationToLoggedUserCompanies(foundPerson);
                }

                vm.step = 2;

                LoadingHelper.stopLoading('.loading-holder');
            }
        }

        function initStepThree() {
            if (vm.urlCompany && vm.urlCompany.Id) {
                vm.hasCompaniesToAssociate = handleAssociationToUrlCompany();
            } else {
                vm.hasCompaniesToAssociate = handleAssociationToLoggedUserCompanies();
            }

            vm.step = 3;

            LoadingHelper.stopLoading('.loading-holder');
        }

        function handleAssociationToLoggedUserCompanies(foundPerson) {
            let hasCompaniesToAssociate = false;

            // Check if person has any companies to be associated or if he is already associated to all companies owned by the logged user
            if (foundPerson && foundPerson.PersonCompanies.length) {
                for (let index = 0; index < loggedPersonAvailableCompanies.length; index++) {
                    const loggedPersonCompany = loggedPersonAvailableCompanies[index];

                    if (foundPerson.PersonCompanies.find(foundPersonCompany => (loggedPersonCompany.CompanyId == foundPersonCompany.CompanyId))) {
                        hasCompaniesToAssociate = false;
                    } else {
                        hasCompaniesToAssociate = true;
                    }
                }

            }
            // If the found person does not have any companies related to him the logged user can associate any company
            else {
                hasCompaniesToAssociate = true;
            }

            // If the found person is not already associated with all companies that the logged person has permission to handle people
            if (hasCompaniesToAssociate) {
                vm.foundPerson = foundPerson;
                vm.loggedPersonAvailableCompanies = loggedPersonAvailableCompanies;
            }

            return hasCompaniesToAssociate;
        }

        function handleAssociationToUrlCompany(foundPerson) {
            let hasCompaniesToAssociate = false;

            // Check if person is already associated to the url company
            if (foundPerson && foundPerson.PersonCompanies.length) {
                if (foundPerson.PersonCompanies.find(foundPersonCompany => (vm.urlCompany.Id != foundPersonCompany.CompanyId)))
                    hasCompaniesToAssociate = true;
            }
            // If the found person does not have any companies related to him the logged user can associate any company
            else {
                hasCompaniesToAssociate = true;
            }

            // If the found person is not already associated with all companies that the logged person has permission to handle people
            if (hasCompaniesToAssociate) {
                vm.foundPerson = foundPerson;
                vm.loggedPersonAvailableCompanies = [{
                    Company: vm.urlCompany,
                    CompanyId: vm.urlCompany.Id
                }];
            }

            return hasCompaniesToAssociate;
        }

        function handlePersonAssociation(isPreRegister) {
            let personCompanyData = vm.personCompanyAssociationData
                .reduce((acc, cur) => {
                    let associationData;

                    if (isPreRegister) {
                        associationData = {
                            CompanyId: cur.CompanyId,
                            ResponsibilityId: cur.ResponsibilityId
                        }
                    } else {
                        associationData = {
                            CompanyId: cur.CompanyId,
                            PersonId: vm.foundPerson.Id,
                            ResponsibilityId: cur.ResponsibilityId
                        }
                    }

                    // If the logged user is currently editing the franchisee of an company set the permission group as franchisee
                    if (vm.isEditingFranchiseeCompany) {
                        associationData.PermissionGroupId = DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE;
                    }

                    // If the logged user is an adminstrator let him choose the permission group of the found person
                    else if (vm.loggedUserData.PermissionGroup.Id == DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISER_ADMINISTRATOR) {
                        associationData.PermissionGroupId = cur.PermissionGroupId;
                    }

                    // If he isn't set the permission group as franchiser worker by default
                    else {
                        associationData.PermissionGroupId = cur.ResponsibilityId != 4 ? DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE_WORKER : DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE;
                    }

                    acc.push(associationData);

                    return acc;
                }, []);

            if (isPreRegister) {
                let preRegisterData = {
                    Name: vm.newUserData.Name,
                    Email: vm.newUserData.Email,
                    CreatorPersonId: vm.loggedUserData.Id,
                    PreRegister_Company: personCompanyData
                }

                PreRegistraterService
                    .createPreRegister(preRegisterData)
                    .then(success => {
                        vm.step = 5;
                        vm.preRegisterPerson = success;

                        LoadingHelper.stopLoading('.loading-holder');
                    }, error => {
                        // When the person already has a pre-register we don't let the user create a new one and inform him
                        if (error.status == 500) {
                            sweetAlert.swal({
                                title: 'Pessoa já possui pré-registro!',
                                text: 'Essa pessoa já possui um pré-registro em andamento, para realizar associação ela deve primeiro finalizar o cadastro.',
                                type: 'warning',
                                confirmButtonText: 'Ok',
                                showCancelButton: false,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then(() => {
                                $timeout(() => {
                                    vm.resetPersonSearch();
                                })
                            })
                        } else {
                            UtilHelper.errorCallback(error);
                        }

                        LoadingHelper.stopLoading('.loading-holder');
                    })
            } else {
                PersonService
                    .associateToCompany(personCompanyData)
                    .then(() => {
                        vm.step = 4;

                        LoadingHelper.stopLoading('.loading-holder');
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.loading-holder');
                    })
            }
        }

        function preInitValidation() {
            loggedPersonAvailableCompanies = AuthenticationService.getCompanyDataByPermissionGroupAndModuleId(vm.loggedUserData.PermissionGroup.Id, SYSTEM_MODULES.FRANCHISER_PEOPLE);

            // Logged person does not have permission to handle person on any company
            if (!loggedPersonAvailableCompanies.length) {
                vm.noCompanyWithPermissions = true;
                vm.showStepOneData = false;
                vm.showStepOneData = false;
            } else {
                vm.showStepOneData = true;
                vm.noCompanyWithPermissions = false;
                vm.errorCantEditSelf = false;
            }
        }

        function init() {
            vm.loggedUserData = AuthenticationService.getUser();
            vm.personCompanyAssociationData = [];

            preInitValidation();

            if (companyId) {
                LoadingHelper.startLoading('.loading-holder');

                CompanyService
                    .get(companyId)
                    .then(success => {
                        if (!success.CompanyIdParent) {
                            sweetAlert.swal({
                                title: 'Não é possível associar um franqueado',
                                text: 'Não é permitido associar franqueados a empresa franqueadora',
                                type: 'warning',
                                confirmButtonText: 'Voltar para empresas',
                                showCancelButton: false,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then(() => {
                                $state.go('app.franchiser-companies')
                            })

                            return;
                        }

                        vm.isEditingFranchiseeCompany = true;
                        vm.urlCompany = success;
                        vm.step = 1;

                        LoadingHelper.stopLoading('.loading-holder');
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.loading-holder');
                    })
            } else
                vm.step = 1;
        }
    }
}());